import { render, staticRenderFns } from "./OrganizationDetailUpdate.vue?vue&type=template&id=515663ba&scoped=true"
import script from "./OrganizationDetailUpdate.vue?vue&type=script&lang=js"
export * from "./OrganizationDetailUpdate.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDetailUpdate.vue?vue&type=style&index=0&id=515663ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515663ba",
  null
  
)

export default component.exports